/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import ImageContain from '@components/global/ImageContain';

import Colors from '@global/colors';

import PropTypes from 'prop-types';

const propTypes = {
  url: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  url: '',
  style: {},
};

const BrandLogo = ({ url = '', style = {} }) => {
  return (
    <View style={[styles.wrapper, style]}>
      <ImageContain source={url} compressWidth={50} width={65} height={18} />
    </View>
  );
};

BrandLogo.propTypes = propTypes;
BrandLogo.defaultProps = defaultProps;

const styles = StyleSheet.create({
  wrapper: {
    width: 65,
    borderRadius: 2,
    borderColor: Colors.grey0,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 4,
  },
});

export default React.memo(BrandLogo, (prev, next) => prev == next);
